import { createIconComponent } from '../createIconComponent';
import { createIconFromSvg } from '../createIconFromSvg';

export const ExternalLink = createIconComponent(
  createIconFromSvg({
    tag: 'svg',
    attr: {
      viewBox: '0 0 24 24',
      fill: 'none',
    },
    child: [
      {
        tag: 'path',
        attr: {
          d: 'M18.4286 12.7714V18.9429C18.4286 20.079 17.5076 21 16.3714 21H5.05714C3.92101 21 3 20.079 3 18.9429V7.62858C3 6.49246 3.92101 5.57144 5.05714 5.57144H11.2286',
          stroke: 'currentColor',
          strokeWidth: '2',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        },
        child: [],
      },
      {
        tag: 'path',
        attr: {
          d: 'M14.5714 3H21V9.42857',
          stroke: 'currentColor',
          strokeWidth: '2',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        },
        child: [],
      },
      {
        tag: 'path',
        attr: {
          d: 'M10.7143 13.2857L21 3',
          stroke: 'currentColor',
          strokeWidth: '2',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
        },
        child: [],
      },
    ],
  })
);
